import { getErrorMessage } from '@/core/lib/utils/get-error-message'
import { IHttpClient } from '@/core/services/http'
import { AxiosError } from 'axios'
import { CitySlugResponse } from '../types/api/city-slug-response'
import { CitySlugModel } from '../types/models/city-slug.model'

export function createGetCitySlugsUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (): Promise<CitySlugModel[]> {
    try {
      const res = await httpClient.version('v1').get<{
        data: CitySlugResponse[]
      }>(`/website/customer/CityPages`)

      return res.data.data
    } catch (err) {
      console.log(
        `Error 🚨🚨🚨🚨🚨 Failed to get cities`,
        getErrorMessage(err),
        err instanceof AxiosError ? err.status : '',
      )

      return []
    }
  }
}
